import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  closeTimingPlaceModalAction,
  useAppDispatch,
} from '../../../../../redux';
import { useWrapInContextNavigation } from '../../../../common/Forms/NavigationBlocker';
import { Modal, ModalBody, ModalHeader } from '../../../../common/Modals';
import { CreateTimingPlaceForm } from './CreateTimingPlaceForm';

const testIds = { modal: 'TimingPlaceModal' };

type CreateTimingPlaceModalProps = {
  readonly onTimingPlaceCreated: (timingPlaceId: UUID) => void;
};

export const CreateTimingPlaceModal: FC<CreateTimingPlaceModalProps> = ({
  onTimingPlaceCreated,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const wrapInContextNavigation = useWrapInContextNavigation(
    'CreateTimingPlaceForm',
  );

  const onCloseModal = () => dispatch(closeTimingPlaceModalAction());
  const onClose = wrapInContextNavigation(onCloseModal);

  const timingPlaceCreated = (timingPlaceId: UUID) => {
    onTimingPlaceCreated(timingPlaceId);
    onCloseModal();
  };

  return (
    <Modal isOpen onClose={onClose} testId={testIds.modal}>
      <ModalHeader onClose={onClose} heading={t(($) => $.timingPlaces.label)} />
      <ModalBody>
        <CreateTimingPlaceForm
          onCancel={onCloseModal}
          onTimingPlaceCreated={timingPlaceCreated}
        />
      </ModalBody>
    </Modal>
  );
};
